import React from 'react'
import type { SpecElementItem } from '@/types/product'
import styles from './SpecRadio.module.less'
import { Badge } from 'antd-mobile'
import useCorpSettingStore from "@/stores/corp-setting";
import { cal, utils, constant } from "@/utils";
import Icon from "@/components/Icon/Icon";
// import CustomizeImageViewerMulti from '@/components/CustomizeImageViewerMulti/CustomizeImageViewerMulti'
// import { Image } from 'antd-mobile'

interface SpecRadioProps {
  nowrap?: boolean
  radioList: SpecElementItem[]
  itemKey: string
  itemName: string
  checked: string
  badgeList: any
  isHaveImg?: boolean // 是否存在 spu 图片 
  onChange: (item: SpecElementItem) => void
  previewImg?: (img: string, elementName?: string) => void
}

interface ComponentProps {
  list: SpecElementItem[]
  start: number
}

const { concatenateImageUrl } = utils
const {
  product: { IMAGE_DEFAULT },
} = constant

const SpecRadio: React.FC<SpecRadioProps> = (props) => {
  const { radioList, checked, badgeList, onChange } = props
  const { corpSetting } = useCorpSettingStore();
  const { qualityPrecision} = corpSetting;
  const half = Math.ceil(cal.divide(radioList.length, 2));
  let isHaveImg = false // 是否存在 spu 图片
  isHaveImg = radioList.findIndex(item => {
    return item.uri
  }) > -1

  function radioChange(index: number) {
    const item = radioList[index]
    onChange(item)
  }

  const RadioItem = (prop: ComponentProps) => {
    const { list, start } = prop
    let radioItemClassNames = styles['radio-item']

    if (isHaveImg) {
      if (radioList.length <= 6) {
        radioItemClassNames = `${radioItemClassNames}` // ${styles['average']}
      } else {
        radioItemClassNames = `${radioItemClassNames} ${styles['img-box']}`
      }
    }

    return list.map((item, index) => {
      const badgeStyles: any = {
        '--right': '100%'
      }
  
      if (index === 0) {
        if (badgeList[item.elementId] >= 1000) {
          badgeStyles['transform'] = 'translate(70%, -50%)'
        }
        if (badgeList[item.elementId] >= 10000) {
          badgeStyles['transform'] = 'translate(85%, -50%)'
        }
      }
      return (
        <div className={radioItemClassNames} key={start + index} data-index={start + index}>
          <Badge
            content={badgeList[item.elementId] ? cal.moneyFormat(badgeList[item.elementId], qualityPrecision) : ''}
            className='badge-wrapper-class'
            style={badgeStyles}
          >
            <div
              className={`${styles['radio']} ${styles['square-radio']} ${checked === item.elementId ? styles['actived'] : ''}`}
            >
              {
                isHaveImg && (
                  <div className={styles['radio-img']}>
                    <div className={styles['icon-wrap']} onClick={() => { props.previewImg && props.previewImg(item.uri || IMAGE_DEFAULT, item.elementName) }}>
                      <Icon name='zoom' color='#fff' size={26} />
                    </div>
                    <img  
                      src={item.uri ? concatenateImageUrl(`${item.uri}_140`) : IMAGE_DEFAULT}
                      onError={(e: any) => { e.target.src = IMAGE_DEFAULT }}
                      onClick={() => { radioChange(start + index) }}
                    />
                  </div>
                )
              }
              <p className={styles['radio-label'] + ' ep'} onClick={() => { radioChange(start + index) }}>{item.elementName}</p>
            </div>
          </Badge>
        </div>
      )
    })
  }

  return (
    <div className={`${styles['radio-list']} ${(radioList.length > 6 && isHaveImg) ? styles['waterfalls'] : ''}`}>
      {
        (radioList.length <= 6 || !isHaveImg) && (<RadioItem list={radioList} start={0} />)
      }

      {
        (radioList.length > 6 && isHaveImg) && (
          <div className={styles['waterfalls-bd']}>
            <div className={styles['waterfalls-item']}>
              <RadioItem list={radioList.slice(0, half)} start={0} />
            </div>
            <div className={styles['waterfalls-item']}>
              <RadioItem list={radioList.slice(half)} start={half} />
            </div>
          </div>
        )
      }
    </div>
  )
}

export default SpecRadio
